module.exports = __webpack_public_path__ + "media/images/pathway_illustrations/pathways-hero-02-194f7e33b06383a329c15eac64cfdb74.svg";